import * as types from './actionTypes';
import initialState from './initialState';

const chatReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case types.GET_CHAT_LOGS_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: true,
        },
      };
    case types.GET_CHAT_LOGS_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: false,
          data: {
            ...state.list.data,
            items: action.payload.chatLogsList,
            count: action.payload.count,
          },
        },
      };
    case types.GET_CHAT_LOGS_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: false,
          error: action.payload.error,
        },
      };
    default:
      return state;
  }
};

export default chatReducer;
